// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingPage_bookingPage__wdM6D {
  display: flex;
  gap: 6rem;
  padding: 3rem 1.3rem;
  background-color: #fff;
  min-height: 100vh;
  justify-content: center;
}
.BookingPage_bookingPage__formSection__JH2Lk {
  flex: 1 1;
  max-width: 650px;
}
.BookingPage_bookingPage__infoCard__od0LB {
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 20px;
  align-self: flex-start;
  width: 41%;
}
@media (max-width: 992px) {
  .BookingPage_bookingPage__wdM6D {
    flex-direction: column-reverse;
    gap: 2rem;
    padding: 0;
  }
  .BookingPage_bookingPage__formSection__JH2Lk {
    order: 2;
    max-width: 100%;
  }
  .BookingPage_bookingPage__infoCard__od0LB {
    order: 1;
    width: 100%;
    padding-left: 1px;
    padding-right: 1px;
  }
}

.BookingPage_proCard__name__lRQFB {
  font-size: 1.85rem;
  font-weight: 400;
  color: #274760;
  margin: 0;
}
.BookingPage_proCard__specialty__BrbFC {
  font-size: 1rem;
  color: #274760;
  margin: 0rem 0 0.7rem 0;
}
.BookingPage_proCard__image__98e3g {
  width: 100%;
  border-radius: 16px;
  margin-bottom: 1.2rem;
  object-fit: cover;
}
.BookingPage_proCard__bio__dnbvP {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #445867;
  margin-bottom: 2rem;
}
.BookingPage_proCard__contactItem__rKPnO {
  margin-bottom: 1rem;
}
.BookingPage_proCard__contactTitle__KKs0e {
  font-size: 1.4rem;
  font-weight: 500;
  color: #274760;
  margin: 0;
}
.BookingPage_proCard__contactValue__1qhfR {
  font-size: 0.95rem;
  color: #274760;
  margin: 0;
  font-weight: 300;
}

@media (max-width: 1260px) {
  .BookingPage_bookingPage__wdM6D {
    gap: 1rem;
    padding: 3rem 16px;
  }
  .BookingPage_bookingPage__infoCard__od0LB {
    padding-left: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Booking/BookingPage.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,SAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;AADJ;AAGI;EACI,SAAA;EACA,gBAAA;AADR;AAII;EACI,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;AAFR;AAKI;EArBJ;IAsBQ,8BAAA;IAEA,SAAA;IACA,UAAA;EAHN;EAKM;IACI,QAAA;IACA,eAAA;EAHV;EAMM;IACI,QAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EAJV;AACF;;AASI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AANR;AASI;EACI,eAAA;EACA,cAAA;EACA,uBAAA;AAPR;AAUI;EACI,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AARR;AAWI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AATR;AAYI;EACI,mBAAA;AAVR;AAaI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAXR;AAcI;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAZR;;AAkBA;EACI;IACI,SAAA;IACA,kBAAA;EAfN;EAiBM;IACI,oBAAA;EAfV;AACF","sourcesContent":["$breakpoint-md: 1260px;\n\n.bookingPage {\n    display: flex;\n    gap: 6rem;\n    padding: 3rem 1.3rem;\n    background-color: #fff;\n    min-height: 100vh;\n    justify-content: center;\n\n    &__formSection {\n        flex: 1;\n        max-width: 650px;\n    }\n\n    &__infoCard {\n        padding: 1.5rem;\n        background-color: #fff;\n        border-radius: 20px;\n        align-self: flex-start;\n        width: 41%;\n    }\n\n    @media (max-width: 992px) {\n        flex-direction: column-reverse;\n\n        gap: 2rem;\n        padding: 0;\n\n        &__formSection {\n            order: 2;\n            max-width: 100%;\n        }\n\n        &__infoCard {\n            order: 1;\n            width: 100%;\n            padding-left: 1px;\n            padding-right: 1px;\n        }\n    }\n}\n\n.proCard {\n    &__name {\n        font-size: 1.85rem;\n        font-weight: 400;\n        color: #274760;\n        margin: 0;\n    }\n\n    &__specialty {\n        font-size: 1rem;\n        color: #274760;\n        margin: 0rem 0 0.7rem 0;\n    }\n\n    &__image {\n        width: 100%;\n        border-radius: 16px;\n        margin-bottom: 1.2rem;\n        object-fit: cover;\n    }\n\n    &__bio {\n        font-size: 0.95rem;\n        line-height: 1.6;\n        color: #445867;\n        margin-bottom: 2rem;\n    }\n\n    &__contactItem {\n        margin-bottom: 1rem;\n    }\n\n    &__contactTitle {\n        font-size: 1.4rem;\n        font-weight: 500;\n        color: #274760;\n        margin: 0;\n    }\n\n    &__contactValue {\n        font-size: 0.95rem;\n        color: #274760;\n        margin: 0;\n        font-weight: 300;\n    }\n\n\n}\n\n@media (max-width: $breakpoint-md) {\n    .bookingPage {\n        gap: 1rem;\n        padding: 3rem 16px;\n\n        &__infoCard {\n            padding-left: 0.8rem;\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingPage": `BookingPage_bookingPage__wdM6D`,
	"bookingPage__formSection": `BookingPage_bookingPage__formSection__JH2Lk`,
	"bookingPage__infoCard": `BookingPage_bookingPage__infoCard__od0LB`,
	"proCard__name": `BookingPage_proCard__name__lRQFB`,
	"proCard__specialty": `BookingPage_proCard__specialty__BrbFC`,
	"proCard__image": `BookingPage_proCard__image__98e3g`,
	"proCard__bio": `BookingPage_proCard__bio__dnbvP`,
	"proCard__contactItem": `BookingPage_proCard__contactItem__rKPnO`,
	"proCard__contactTitle": `BookingPage_proCard__contactTitle__KKs0e`,
	"proCard__contactValue": `BookingPage_proCard__contactValue__1qhfR`
};
export default ___CSS_LOADER_EXPORT___;
